<template>
  <div>
    <PageAllow controller="SupplierMaterials" action="index" />
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="transparent-background-color" v-show="!currentItemMode">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherKeyword
                ref="keyword"
                v-model="options.keyword"
                @text="keyword = $event"
                :label="$t('Materials.Fields.keyword')"
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherSupplierMaterialCategories
                v-model="materialCategoriesSelected"
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="4" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>

              <v-spacer />
              <!-- 新增 -->
              <!-- <v-btn small color="print" dark class="ms-1" 
                    @click.stop="
                    currentItemMode = 'new';
                    currentItem = {};
                ">
                {{ $t("Materials.add") }}
              </v-btn> -->
              <!-- 导入 -->

              <v-btn
                v-if="
                  accountUser &&
                  accountUser.supplier &&
                  accountUser.supplier.edit_material_flg == 1
                "
                small
                color="print"
                dark
                @click.stop="ImportDialog = true"
                class="ms-1"
              >
                <v-icon x-small class="pe-1">fa-file-import</v-icon>
                {{ $t("Materials.modifyMaterialImport") }}
              </v-btn>
              <!-- 批量导出 -->
              <v-btn
                small
                color="print"
                dark
                class="ms-1"
                @click.stop="Export()"
              >
                {{ $t("Materials.batch_export") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
        <!-- 表格 -->
        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="materials"
            :options.sync="options"
            :loading="loading"
            :page.sync="paging.page"
            :server-items-length="paging.count"
            multi-sort
            class="elevation-1 px-4 pt-1"
            :footer-props="$t('$config.footer-props')"
          >
            <template v-slot:header.actions="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template>
            <!-- 查看 编辑  -->
            <template v-slot:item.actions="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    dark
                    color="secondary"
                    class="px-1 me-1"
                    @click.stop="
                      currentItemMode = 'view';
                      currentItem = item;
                    "
                    >fa-file-alt
                  </v-icon>
                </template>
                <span>{{ $t("Materials.Fields.view") }}</span>
              </v-tooltip>
              <v-tooltip top v-if="item.actions.edit">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    dark
                    color="primary"
                    class="px-1 me-1"
                    @click.stop="
                      currentItemMode = 'edit';
                      currentItem = item;
                    "
                  >
                    fa-pencil-alt
                  </v-icon>
                </template>
                <span>{{ $t("Materials.Fields.edit") }}</span>
              </v-tooltip>
            </template>

            <template v-slot:item.supply_price="{ item }">
              <a @click.stop="
                currentDetail = item;
                lineChartMaterialName = $t(
                  settings
                    ? settings.material_name_display_type == 3
                      ? 'Material.materialNameWithCodeAndStandard'
                        : settings.material_name_display_type == 2
                        ? 'Material.materialNameWithCode'
                      : 'Material.materialName'
                    : 'Material.materialName',
                  [item.material.material_code, item.material.material_name, item.standard.name]
                );
                echartsDialog = true;">
                {{ $t("Global.money") }}{{ item.supply_price | formatMoney }}
              </a>
            </template>
            <template v-slot:item.shop_supply_price="{ item }">
              {{ $t("Global.money")
              }}{{
                item.material ? item.material.supply_price : "" | formatMoney
              }}
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
    <MaterialsDetail
      v-show="currentItemMode"
      v-model="currentItem"
      :mode="currentItemMode"
      v-on:mode="currentItemMode = $event"
      v-on:save="getMaterialFromAPI()"
    />
    <ImportExcelAlert
      v-model="ImportDialog"
      :objName="$t('Materials.modifyMaterial')"
      downloadFromAPI
      @import="
        excelFile = $event;
        importExcel();
      "
      @download="templateExport()"
    />
    <DialogEconomyHistoryEcharts
      v-model="echartsDialog"
      :supplierId="accountUser.supplier_id"
      :currentDetail="currentDetail"
      :lineChartMaterialName="lineChartMaterialName"
      @close="echartsDialog = false"
    />
  </div>
</template>

<script>
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherSupplierMaterialCategories from "@/components/plugins/SearcherSupplierMaterialCategories";
import Material from "@/api/supplier_materials";
import MaterialsDetail from "./plugins/Detail";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import { mapState } from "vuex";
import ImportExcelAlert from "@/components/plugins/ImportExcelAlert";
import DialogEconomyHistoryEcharts from "@/components/plugins/DialogEconomyHistoryEcharts"

const defaultOptions = {
  keyword: "",
};

export default {
  data: () => ({
    materials: [],
    materialCategoriesSelected: [],
    paging: {},
    loading: false,
    category_ids: [],
    options: JSON.parse(JSON.stringify(defaultOptions)),
    currentItem: null,
    currentItemMode: null,
    keyword: "",
    ImportDialog: false,
    excelFile: null,
    echartsDialog: false,
    currentDetail: null,
    lineChartMaterialName: "",
  }),

  components: {
    PageAllow,
    Breadcrumbs,
    SearcherSupplierMaterialCategories,
    MaterialsDetail,
    SearcherKeyword,
    ImportExcelAlert,
    DialogEconomyHistoryEcharts,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.materialManagement"),
        disabled: false,
        href: "/supplier-materials",
      },
      {
        text: i18n.t("Nav.materials"),
        disabled: true,
        href: "/supplier-materials",
      },
    ],

    headers() {
      let item =  [
        {
          text: i18n.t("Materials.Fields.category"),
          align: "start",
          sortable: false,
          value: "material.material_category.name",
        },
        {
          text: i18n.t("Materials.Fields.material_code"),
          align: "start",
          sortable: false,
          value: "material.material_code",
        },
        {
          text: i18n.t("Materials.Fields.supply_code"),
          align: "start",
          sortable: false,
          value: "supply_code",
        },
        {
          text: i18n.t("Materials.Fields.material_name"),
          align: "start",
          sortable: false,
          value: "material.material_name",
        },
        {
          text: i18n.t("Materials.Fields.standards"),
          align: "start",
          sortable: false,
          value: "standard.name",
        },
        {
          text: i18n.t("Materials.Fields.unit"),
          align: "start",
          sortable: false,
          value: "standard_detail.unit",
        },
        {
          text: i18n.t("Materials.Fields.price"),
          align: "end",
          sortable: false,
          value: "supply_price",
        }
      ];
      if (this.accountUser && this.accountUser.supplier && this.accountUser.supplier.edit_material_flg) {
        item.push(
          {
            text: i18n.t("Materials.Fields.supply_price", [
              this.$consts.shopName(),
            ]),
            align: "end",
            sortable: false,
            value: "shop_supply_price",
          }
        )
      }
      item.push(
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        }
      )
      return item;
    },
    ...mapState(["accountUser", "settings"]),
  },

  mounted() {
    this.$commonUtils
      .loadOptions("supplier-materials", ["materialCategoriesSelected"])
      .then(
        function (data) {
          if (data.options) {
            this.options = data.options;
          } else this.resetSearch();
          data.selecteds.forEach((selected) => {
            switch (selected.key) {
              case "materialCategoriesSelected":
                this.materialCategoriesSelected = selected.value;
                break;
            }
          });
        }.bind(this)
      );
  },

  methods: {
    onSearch() {
      this.options = Object.assign(this.options, {
        keyword: this.keyword,
      });
      this.getMaterialFromAPI();
    },
    resetSearch() {
      this.materialCategoriesSelected = [];

      this.options = JSON.parse(JSON.stringify(defaultOptions));
      this.getMaterialFromAPI();
    },
    getMaterialFromAPI() {
      this.loading = true;
      Material.fetch(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.materials = response.data.materials;
            this.paging = response.data.paging;
            // console.log(this.materials);
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
          this.loading = false;
        }.bind(this)
      );
    },
    Export() {
      Material.exportBatch(
        Object.assign(this.options, {
          supplier_id: this.$store.getters.supplierId,
        })
      );
    },
    importExcel() {
      this.$store.dispatch("fullscreenLoading");
      Material.modifyMaterialImport(
        this.$store.getters.supplierId,
        this.excelFile
      )
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              if (response.data.err_data && response.data.err_data.length) {
                this.$snackbar.error(i18n.t(response.data.err_data[0].msg));
              } else {
                this.$snackbar.info(
                  i18n.t("Import.success", [i18n.t("Materials.modifyMaterial")])
                );
                this.ImportDialog = false;
                this.getMaterialFromAPI();
              }
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    templateExport() {
      Material.exportTemplate(this.$store.getters.supplierId);
    },
  },

  watch: {
    $route() {
      if (!this.$route.query.id) {
        this.currentItemMode = null;
        this.currentItem = null;
      }
    },

    currentItem: {
      handler() {
        if (this.currentItem) {
          this.$router.replace(
            "/supplier-materials?id=" + this.currentItem.material_id
          );
          this.$cacheScrollLocation();
        } else {
          this.$scrollToCachedLocation();
          this.$router.replace("/supplier-materials");
        }
      },
    },

    options: {
      deep: true,
      handler() {
        sessionStorage.setItem(
          "supplier-materials-options",
          JSON.stringify(this.options)
        );
        this.getMaterialFromAPI();
      },
    },
    // 商品分类
    materialCategoriesSelected: {
      handler() {
        this.options.category_ids = this.materialCategoriesSelected
          ? this.materialCategoriesSelected.map((e) => {
              return e.id;
            })
          : "";
        sessionStorage.setItem(
          "supplier-materials-materialCategoriesSelected",
          JSON.stringify(this.materialCategoriesSelected)
        );
      },
    },
  },
};
</script>

<style>
</style>